import Vue from 'vue';

import _ from "lodash";

let videos = {
      state: {
        list:[],
        loaded:false
      },
      mutations:{

      },
      actions:{
          loadVideos({  state }){
              Vue.http.get("content/videos").then((res) => {
                  state.list = _(state.list) // start sequence
                    .keyBy('_id') // create a dictionary of the 1st array
                    .merge(_.keyBy(res.body.videos, '_id')) 
                    .values().value()
              });
          }
      }
  };
  export default videos;